import styled from 'styled-components';
import { PropertyCardSaveButtonMixin } from '../../mixins/components/PropertyCardSaveButtonMixin';
import { ToggleButton } from '../ToggleButton/ToggleButton';
export var StyledPropertyCardSaveButton = /*#__PURE__*/styled(ToggleButton).withConfig({
  displayName: "StyledPropertyCardSaveButton",
  componentId: "c11n-8-111-1__sc-ianvq6-0"
})(["", ""], PropertyCardSaveButtonMixin);